<template>
    <div>
        <!-- Header -->
         <!-- Abdullah 19-05-26 removed border-bottom -->
        <div class="clearfix row py-2 mb-2 no-margin">
            <!-- Abdullah 19-05-26 added pl-0  -->
            <div class="col-sm-6 company-form-box-title pb-3 pl-0">
                Compensatory Leave
            </div>
            <div class="col-sm-6 text-right px-0 custom-left-btn-float-left">
                <b-button v-if="employee_id && ce" @click="addNew">Apply Leave</b-button>
            </div>
        </div>

        <!-- Table -->
        <div class="row justify-content-center no-margin">
            <div class="col-sm-12 px-0">
                <b-overlay :show="showoverlay_list" rounded="sm">
                    <div class="table-responsive">
                        <table class="table dataTable border">
                        <thead>
                            <tr class="table-head">
                            <template v-for="column in columns">
                                <th v-if="column.sort" @click="sortBy(column.name)"
                                    :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                    style="cursor:pointer;"><span>{{ column.label }}</span></th>
                                <th v-else><span>{{ column.label }}</span></th>
                            </template>

                                <td class="text-center" v-if="ce">Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(leave, index) in paginatedData" :key="index">
                                <td>{{ leave.employee_name }}</td>
                                <td>{{ leave.department_name }}</td>
                                <td>{{ leave.jobposition_name }}</td>
                                <td>{{ leave.leave_date }}</td>
                                <td>{{ leave.attendance_date }}</td>
                                <td>{{ leave.reason }}</td>

                                <!-- 27 july 2025 asfaq -->

                                <td class="text-center status-wrapper" :class="status[leave.status].text.toLowerCase()">

                                    <span class="leave-status" v-if="status[leave.status].text == 'Approved'"><i class="fa fa-circle mr-1"></i>{{ status[leave.status].text }}</span>
                                    <span class="leave-status" v-if="status[leave.status].text == 'Applied'"><i class="fa fa-circle mr-1"></i>{{ status[leave.status].text }}</span>
                                    <span class="leave-status" v-if="status[leave.status].text == 'Declined'"><i class="fa fa-circle mr-1"></i>{{ status[leave.status].text }}</span>
                                </td>
                                <td>{{ leave.updated_by }}</td>
                                <!-- 27 july 2025 asfaq -->


                                <!-- Abdullah responsive added text-right  -->
                                <td class="position-relative text-right pr-3" v-if="ce">
                                    <template  v-if="leave.edit">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                            style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false"><b-icon
                                                icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu w-200 py-1"
                                            aria-labelledby="actionDropdown">
                                            <b-button-toolbar class="">
                                                <b-button-group class="mr-0">
                                                    <b-button v-if="leave.status != 1" class="rounded delete-btn" title="Approve" @click="updateLeave(leave.id, 1)">
                                                        <b-icon icon="check" class="mr-2" aria-hidden="true"></b-icon>Approve
                                                    </b-button>
                                                    <b-button v-if="leave.status != 2" class="rounded delete-btn" title="Reject" @click="updateLeave(leave.id, 2)">
                                                        <b-icon icon="x" class="mr-2" aria-hidden="true"></b-icon>Reject
                                                    </b-button>
                                                    <b-button v-if="leave.status == 2" class="rounded delete-btn" title="Delete"
                                                        @click="deleteLeave(leave.id, employee_id)">
                                                        <b-icon icon="trash" class="mr-2"
                                                            aria-hidden="true"></b-icon>Delete
                                                    </b-button>
                                                </b-button-group>
                                            </b-button-toolbar>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"  v-if="leave.status == 0"
                                            style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false"><b-icon
                                                icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu w-200 py-1"
                                            aria-labelledby="actionDropdown">
                                            <b-button-toolbar class="">
                                                <b-button-group class="mr-0">
                                                    <b-button class="rounded delete-btn" title="Delete"
                                                        @click="deleteLeave(leave.id, employee_id)">
                                                        <b-icon icon="trash" class="mr-2"
                                                            aria-hidden="true"></b-icon>Delete
                                                    </b-button>
                                                </b-button-group>
                                            </b-button-toolbar>
                                        </div>
                                    </template>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>

                    <div v-if="paginatedData.length == 0" class="list-no-data">
                        No records found.
                    </div>
                    <div v-else class="">
                            <!-- <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ><template #prev-text><span>Previous</span></template><template #next-text><span>Next</span></template></b-pagination-nav>
                        -->
                        <div class="clearfix mt-2 mb-4">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                            </ul>
                            <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>

                        </div>
                    </div>
                </b-overlay>
            </div>
        </div>

        <b-modal id="bv-modal-add-compensatory-leave" size="xl" scrollable hide-footer title="Add Compensatory Leave">
            <l-a-ess-compensatory-leaves-employee-leave-details v-if="this.employee_id > 0"
                :employee_id="this.employee_id" :fdata="this.fdata"
                v-on:childToParent="getLeaves"></l-a-ess-compensatory-leaves-employee-leave-details>
        </b-modal>

    </div>
</template>

<script>
export default {
    data() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            let sortOrders = {};
            let columns = [
                { label: 'Employee Name', name: 'employee_name', sort: true },
                { label: 'Department', name: 'department_name', sort: true },
                { label: 'Job Position', name: 'jobposition_name', sort: true },
                { label: 'Leave Date', name: 'leave_date', type: 'date', sort: true },
                { label: 'Used Attendance Date', name: 'attendance_date', type: 'date', sort: true },
                { label: 'Reason', name: 'reason', sort: true },
                { label: 'Status', name: 'status', type: 'number', sort: true },
                { label: 'Updated By/Initiated By', name: 'updated_by', sort: true },
            ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});
        return {
            leaves: [],
            showoverlay_list: false,
            ce: true,
            status: [
                { text: 'Applied', value: '0', variant: 'warning' },
                { text: 'Approved', value: '1', variant: 'success' },
                { text: 'Declined', value: '2', variant: 'danger' },
            ],
            fdata: { is_edit: 1, id: 0, employee_id: 0, leave_date: today, attendance_date: null, status: 0, reason: '' },
            pagination: {currentPage: 1, pages:1},
            temp_length: 20,
            length_options: [{ value: 10, text: "10" },{ value: 20, text: "20" },
                                                    { value: 50, text: "50" },
                                                    { value: 100, text: "100" },
                                                    { value: 200, text: "200" },
                                                    { value: 500, text: "500" }, ],
            columns: columns,
            sortKey: 'employee_name',
            sortOrders: sortOrders,
        };
    },
    props: ['employee_id'],
    created: function () {
        this.getLeaves();
    },
    methods: {
        getLeaves() {
            this.showoverlay_list = true;
            axios
                .get(this.$api_url + '/front/compensatory-leave-list')
                .then((response) => {
                    this.leaves = response.data.compensatory_leave_list;
                    this.showoverlay_list = false;
                    this.length_options.push({ value: this.leaves.length, text: "All" });
                })
                .catch((err) => {
                    console.error('Error fetching leaves:', err);
                    this.leaves = [];
                    this.showoverlay_list = false;
                });
            this.$bvModal.hide('bv-modal-add-compensatory-leave');
        },
        addNew() {
            this.$bvModal.show('bv-modal-add-compensatory-leave');
        },
        deleteLeave: function (id) {
            this.showoverlay = true;
            let formData = new FormData();
            formData.append('id', id);
            axios.post(this.$api_url + '/front/compensatory-leave-delete', formData)
                .then(function (response) {
                    this.$bvToast.toast('Deleted!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });

                    this.getLeaves();

                }.bind(this))
                .catch(error => {
                    const message =
                        error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'An unexpected error occurred.';

                    this.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                })
                .finally(() => {
                    this.showoverlay = false;
                });
        },
        updateLeave: function (id, status) {
            this.showoverlay = true;
            let formData = new FormData();
            formData.append('id', id);
            formData.append('status', status);
            axios.post(this.$api_url + '/front/compensatory-leave-update', formData)
                .then(function (response) {
                    this.$bvToast.toast('Deleted!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });

                    this.getLeaves();

                }.bind(this))
                .catch(error => {
                    const message =
                        error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'An unexpected error occurred.';

                    this.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                })
                .finally(() => {
                    this.showoverlay = false;
                });
        },
    },

        computed:
        {
            filteredData()
            {
                let filtered_list = this.leaves;
                this.people = this.leaves.length;
                if (this.search)
                {

                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
            },

            fetchStartWeekday()
            {
                return this.week_start_day;
            },
        },
};
</script>

<style scoped>
.img-holder {
    cursor: not-allowed;
    pointer-events: none;
}

.employee-avatar {
    width: 40px;
    height: 40px;
}

.table-head {
    font-weight: bold;
}
</style>
